import { onMounted, onBeforeUnmount, unref } from 'vue';

import $ from 'jquery';

export function useBootstrapEvents(element, emit, eventNames, { fullName = false, eventSuffix = '' }) {
    for (const name of eventNames) {
        const bsName = name + eventSuffix;
        const handler = (event) => {
            if (eventSuffix && event.namespace !== eventSuffix) {
                return;
            }
            emit(fullName ? bsName : name, event);
        };

        onMounted(() => $(unref(element)).on(bsName, handler));
        onBeforeUnmount(() => $(unref(element)).off(bsName, handler));
    }
}
